import {useEntity} from "state/hooks/useEntity";
import {useField} from "state/hooks/useField";

export function useFormField(field) {
    const {type, id} = useEntity();
    return useField(type, id, field);
}